module.exports = __webpack_public_path__ + "static/6-796579a118a1ea99799c65730e9a2346.jpg";